import { useEffect, useState, useContext } from "react";
import isValidCoupon from "../lib/coupons/isValidCoupon";
import { CartContext } from "../../state/contexts/cartState";
import { useApiCall } from "./useApiCall";
import { useAuth } from "./useAuth";

export const useCouponCode = () => {
  const { applyCoupon, removeCoupon, couponCode, cartItems } =
    useContext(CartContext);

  const [couponError, setCouponError] = useState();
  const [couponId, setCouponId] = useState(couponCode.id ?? null);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const { user } = useAuth();

  const { executeApiCall, apiCallStatus, apiCallResponse } = useApiCall();

  const applyCouponCode = (coupon) => {
    if (coupon) {
      setCouponError();
      removeCouponCode();

      const requestOptions = {
        url: `/coupons/${coupon}`,
        method: "GET",
      };

      executeApiCall(requestOptions);

      setIsApplyingCoupon(true);
    }
  };

  const removeCouponCode = () => {
    removeCoupon({});
    setCouponId("");
  };

  useEffect(() => {
    if (couponCode.id) {
      setCouponId(couponCode.id);
    } else {
      setCouponId("");
    }
  }, [couponCode]);

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        setIsApplyingCoupon(false);

        if (apiCallResponse.data.data) {
          const { coupon } = apiCallResponse.data.data;

          const { error } = isValidCoupon(coupon, { user, cartItems });

          if (error) {
            setCouponError(error);
          } else {
            applyCoupon({
              couponCode: coupon,
            });
          }
        } else {
          const { error } = apiCallResponse.data;

          setCouponError(error.userMessage);
        }
        break;
    }
  }, [apiCallStatus, apiCallResponse, cartItems]);

  return {
    couponError,
    applyCouponCode,
    removeCouponCode,
    couponId,
    isApplyingCoupon,
  };
};
